<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>Remessa TCEPE - Modelo de Planilha do Orçamento e Resultados</span>
                </h4>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <div>
                    <b-row>
                        <b-col sm="12" md="12">
                            <b-form-group>
                                <label for="selectListaContratos" class="required">Contrato</label>
                                <b-input-group>
                                    <b-form-select
                                        id="selectListaContratos"
                                        :options="listaContratos"
                                        v-model="idContratoSelecionado"
                                        text-field="vcCodigoEstruturado"
                                        value-field="idContrato"
                                        @input.native="$v.idContratoSelecionado.$touch()"
                                    ></b-form-select>
                                </b-input-group>
                            </b-form-group>
                        </b-col> 
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="inputNumeroDoItem" class="required">Número do Item</label>
                                <b-input-group>
                                    <b-form-input
                                        id="inputNumeroDoItem"
                                        type="number"
                                        min="1"
                                        step="1"
                                        placeholder="Número do Item"
                                        v-model="numeroItem"
                                        @input.native="$v.numeroItem.$touch()"
                                        @focus="$v.numeroItem.$touch()"
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.numeroItem.$dirty &&
                                            $v.numeroItem.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Número do Item é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="selectTipoBeneficio" class="required">Tipo Benefício</label>
                                 <b-form-select
                                    id="selectTipoBeneficio"
                                    :options="listaTipoBeneficio"
                                    v-model="tipoBeneficio"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="$v.tipoBeneficio.$touch()"
                                ></b-form-select>
                                <b-form-invalid-feedback>Tipo Benefício é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>    
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="selectMaterialServico" class="required">Material Serviço</label>
                                 <b-form-select
                                    id="selectMaterialServico"
                                    :options="listaMaterialServico"
                                    v-model="materialServico"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="$v.materialServico.$touch()"
                                ></b-form-select>
                                <b-form-invalid-feedback>Material Serviço é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="selectFonteReferencia" class="required">Fonte de Referência</label>
                                 <b-form-select
                                    id="selectFonteReferencia"
                                    :options="listaFonteDeReferencia"
                                    v-model="fonteReferencia"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="$v.fonteReferencia.$touch()"
                                ></b-form-select>
                                <b-form-invalid-feedback>Fonte de Referência é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>                                                  
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="dataReferencia" class="required">Data de Referência</label>
                                <date-picker
                                    id="dataReferencia"
                                    v-model="dataReferencia"
                                    :config="$datePickerOptions"
                                    v-mask="'##/##/####'"
                                    @input.native="$v.dataReferencia.$touch()"
                                    :state="stateInputDataReferencia"
                                ></date-picker>
                                <b-form-invalid-feedback :state="stateInputDataReferencia">Data de Referência é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col> 
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="selectCodigoReferencia" class="required">Código de Referência</label>
                                <b-input-group>
                                    <b-form-input
                                        id="inputCodigoReferencia"
                                        type="text"
                                        maxlength="100"
                                        placeholder="Código de Referência"
                                        @input.native="$v.codigoDeReferencia.$touch()"
                                        @focus="$v.codigoDeReferencia.$touch()"                                        
                                        v-model="codigoDeReferencia"
                                    ></b-form-input>
                                    <div
                                        v-if="
                                            $v.codigoDeReferencia.$dirty &&
                                            $v.codigoDeReferencia.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        {{$v.codigoDeReferencia.required === false ? 'Código de Referência é obrigatório' : 'Máx. 100 caracteres'}}
                                    </div>                                    
                                </b-input-group>
                            </b-form-group>
                        </b-col>   
                    </b-row>

                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label for="textAreaDescricaoItem" class="required">Descrição do Item</label>
                                <b-form-textarea
                                    id="textAreaDescricaoItem"
                                    v-model="descricaoItem"
                                    :rows="2"
                                    @input.native="$v.descricaoItem.$touch()"
                                    @focus="$v.descricaoItem.$touch()"
                                    :state="stateInputDescricaoDoItem"
                                    maxlength="8000"
                                ></b-form-textarea>
                                <div
                                    v-if="
                                        $v.descricaoItem.$dirty &&
                                        $v.descricaoItem.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Descrição do Item é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col sm="12">
                            <b-form-group>
                                <label for="textAreaDescricaoLote" class="required">Descrição do Lote</label>
                                <b-form-textarea
                                    id="textAreaDescricaoLote"
                                    v-model="descricaoLote"
                                    :rows="2"
                                    @input.native="$v.descricaoLote.$touch()"
                                    @focus="$v.descricaoLote.$touch()"
                                    :state="stateInputDescricaoDoLote"
                                    maxlength="100"
                                ></b-form-textarea>
                                <div
                                    v-if="
                                        $v.descricaoItem.$dirty &&
                                        $v.descricaoItem.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Descrição do Lote é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="inputUnidadeDeMedida" class="required">Unidade Medida</label>
                                <b-form-input
                                    id="inputUnidadeDeMedida"
                                    type="text"
                                    maxlength="10"
                                    placeholder="Unidade Medida"
                                    @input.native="$v.unidadeMedida.$touch()"
                                    @focus="$v.unidadeMedida.$touch()"
                                    v-model="unidadeMedida"
                                ></b-form-input>
                                <div
                                    v-if="
                                        $v.unidadeMedida.$dirty &&
                                        $v.unidadeMedida.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    {{$v.unidadeMedida.required === false ? 'Unidade Medida é obrigatório' : 'Máx. 10 caracteres'}}
                                </div>
                            </b-form-group>
                        </b-col>  
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="moQuantidade" class="required">Quantidade</label>
                                <money
                                    id="moQuantidade"
                                    v-model="quantidade"
                                    v-bind="quantidadeConfig"
                                    class="form-control text-right"
                                    @input.native="$v.quantidade.$touch()"
                                    @focus="$v.quantidade.$touch()"
                                ></money> 
                                <div
                                    v-if="
                                        $v.quantidade.$dirty &&
                                        $v.quantidade.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    Quantidade é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>  
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="moValorUnitario" class="required">Valor Unitário</label>
                                <b-input-group>
                                    <money
                                        id="moValorUnitario"
                                        v-model="valorUnitario"
                                        v-bind="money"
                                        class="form-control text-right"
                                        @input.native="$v.valorUnitario.$touch()"
                                        @focus="$v.valorUnitario.$touch()"
                                    ></money>  
                                    <div
                                        v-if="
                                            $v.valorUnitario.$dirty &&
                                            $v.valorUnitario.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Valor Unitário é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col sm="12" md="3">
                            <b-form-group>
                                <label for="moValorTotal" class="required">Valor Total</label>
                                <b-input-group>
                                    <money
                                        id="moValorTotal"
                                        v-model="valorTotal"
                                        v-bind="money"
                                        class="form-control text-right"
                                        @input.native="$v.valorTotal.$touch()"
                                        @focus="$v.valorTotal.$touch()"
                                    ></money>  
                                    <div
                                        v-if="
                                            $v.valorTotal.$dirty &&
                                            $v.valorTotal.$invalid
                                        "
                                        class="invalid-feedback d-block"
                                    >
                                        Valor Total é obrigatório
                                    </div>
                                </b-input-group>
                            </b-form-group>
                        </b-col>                         
                    </b-row>

                    <b-row>
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="textoBDI" class="required">BDI</label>
                                <b-form-input
                                    id="textoBDI"
                                    type="text"
                                    max="10"
                                    placeholder="BDI"
                                    @input.native="$v.bdi.$touch()"
                                    @focus="$v.bdi.$touch()"
                                    v-model="bdi"
                                ></b-form-input>
                                <div
                                    v-if="
                                        $v.bdi.$dirty &&
                                        $v.bdi.$invalid
                                    "
                                    class="invalid-feedback d-block"
                                >
                                    BDI é obrigatório
                                </div>
                            </b-form-group>
                        </b-col>    
                        <b-col sm="12" md="6">
                            <b-form-group>
                                <label for="selectIndiceDeAtualizacoes" class="required">Índice de Atualização</label>
                                 <b-form-select
                                    id="selectIndiceDeAtualizacoes"
                                    :options="listaIndiceDeAtualizacoes"
                                    v-model="indiceAtualizacao"
                                    text-field="nome"
                                    value-field="codigo"
                                    @input.native="$v.indiceAtualizacao.$touch()"
                                ></b-form-select>
                                <b-form-invalid-feedback>Índice de Atualização é obrigatório</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>  
                    </b-row>

                </div>
            </b-card-body>
            <b-card-footer>                
                <b-button
                    variant="primary"
                    class="mr-2"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="salvar()">
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Planilha
                    </span>
                </b-button>
            </b-card-footer>  
        </b-card>
    </div>
</template>

<script>
import { maxLength } from 'vuelidate/lib/validators'
import { required, minValue } from 'vuelidate/lib/validators'
import GestaoJuridicaServicos from '../../GestaoJuridicaServicos'

export default {
    methods: {
        calcularValorTotal() {
            const qtd = Number(this.quantidade) || 0
            const vu  = Number(this.valorUnitario) || 0
            this.valorTotal = qtd * vu
        },

        salvar() {
            var dto = {
                CnpjContratada: this.onlyDigits(this.contrato.fornecedor.cnpj),
                NumeroItem: this.numeroItem,
                MaterialServico: this.materialServico,
                FonteReferencia: this.fonteReferencia,
                DataReferencia: this.toIsoDate(this.dataReferencia),
                CodigoReferencia: this.codigoDeReferencia,
                UnidadeMedida: this.unidadeMedida,
                Quantidade: this.converterParaFloat(this.quantidade),
                DescricaoItem: this.descricaoItem,
                ValorUnitario: this.converterParaFloat(this.valorUnitario),
                ValorTotal: this.converterParaFloat(this.valorTotal),
                Bdi: this.bdi,
                indiceAtualizacao: this.indiceAtualizacao,
                TipoBeneficio: this.tipoBeneficio,
                DescricaoLote: this.descricaoLote
            };

            this.$store.dispatch('addRequest');

            GestaoJuridicaServicos
                .GerarPlanilhaRelatorioOrcamentoResultados(dto)
                .then((res) => {                
                    this.abrirListaDePlanilha(dto.CnpjContratada);
                    this.$toast.success('Relatório Salvo Com Sucesso.', 'OK', this.$toastConfig.success);
                })
                .catch(() => {
                this.$toast.error('Falha ao enviar ao backend.', 'ERRO', this.$toastConfig.error);
                })
                .finally(() => this.$store.dispatch('removeRequest'));
        },

        toIsoDate: (s) => {
            // aceita "dd/MM/yyyy" do date-picker e converte pra "yyyy-MM-dd"
            if (!s) return null;
            const [dd, mm, yyyy] = String(s).split('/');
            if (!dd || !mm || !yyyy) return null;
            return `${yyyy}-${mm.padStart(2,'0')}-${dd.padStart(2,'0')}`;
        },

        verificarCampoPreenchido(value) {
            if (value == null || value == '' || value == undefined)
                return false
            else
                return true
        },

        obterListaFonteReferencia() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterFonteDeReferencias().then(response => {
                if (response) {
                    if (response.success) {
                        this.listaFonteDeReferencia = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter Fonte de Referência',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    
        obterListaIndiceAtualizacoes() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterListaIndiceAtualizacoes().then(response => {
                if (response) {
                    if (response.success) {
                        this.listaIndiceDeAtualizacoes = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter Índice de Atualizações',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }, 

        obterListaTipoBenefico() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterListaTipoBenefico().then(response => {
                if (response) {
                    if (response.success) {
                        this.listaTipoBeneficio = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter Tipo Benefício',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        converterParaFloat(valorString) {
            const normalizado = valorString.toString().replace(/\./g, '').replace(',', '.')
            return parseFloat(normalizado)
        },

        onlyDigits: (s) => (s || '').replace(/\D+/g, ''),

        abrirListaDePlanilha(cnpj) {
            this.$router.push({
                name: `Contratos_Relatorios_OrcamentoEResultados`,
                params: {
                    cnpj: this.onlyDigits(cnpj)
                }                
            })
        },

        obterContratos() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterContratosVigentes().then((response) => {
                if (response) {
                    if (response.success) {
                        this.listaContratos = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter lista de contratos!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDadosContrato() {
            this.$store.dispatch('addRequest')
            GestaoJuridicaServicos.obterContratosPorId(this.idContratoSelecionado).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencherDadosContrato(response.data)
                    } else {
                        this.$toast.error(
                            'Erro ao obter contrato!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencherDadosContrato(contrato) {
            // preencher dados com valores vindos do contrato
            // this.numeroDoItem = ?
            // this.descricaoDoItem = ?
            // this.unidadeDeMedida = ?
            // this.quantidade = ?
            // this.valorUnitario = ?
            // this.valorTotal = contrato.nuValorGlobalContrato

            // testes apagar antes de commitar
            // this.numeroDoItem = 1
            // this.descricaoDoItem = "TESTE"
            // this.fonteDeReferencia = this.listaFonteDeReferencia[0].codigo
            // this.dataDeReferencia = "18/09/2025"
            // this.codigoDeReferencia = 45
            // this.unidadeDeMedida = "T"
            // this.quantidade = 5
            // this.valorUnitario = 56.59
            // this.bdi = "T"
            // this.indiceDeAtualizacao = this.listaIndiceDeAtualizacoes[0].codigo

            this.contrato = contrato
        },        
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        stateInputDataReferencia() {
            if (this.$v)
                if (this.$v.dataReferencia.$invalid && this.$v.dataReferencia.$dirty) 
                    return false
            return null
        },

        stateInputDescricaoDoLote() {
            if (this.$v)
                if (this.$v.descricaoLote.$invalid && this.$v.descricaoLote.$dirty) 
                    return false
            return null 
        },

        stateInputDescricaoDoItem() {
            if (this.$v)
                if (this.$v.descricaoItem.$invalid && this.$v.descricaoItem.$dirty) 
                    return false
            return null 
        },

        dataDeReferenciaValida() {
            if (this.verificarCampoPreenchido(this.dataReferencia)) {
                const data = this.$moment(this.dataReferencia, 'DD/MM/YYYY')
                const limiteInferior = this.$moment('01/01/2000', 'DD/MM/YYYY')
                const hoje = this.$moment()

               return data.isSameOrAfter(limiteInferior) && data.isSameOrBefore(hoje)
            }
            return false;
        },
    },


    data() {
        return {
            erros: [],
            listaMaterialServico: [
                {codigo: "M", nome: "M"},
                {codigo: "S", nome: "S"},
            ],
            listaFonteDeReferencia: [],
            listaIndiceDeAtualizacoes: [],
            listaTipoBeneficio: [],
            listaContratos: [],
            idContratoSelecionado: null,
            contrato: null,
            // numeroDoLote: 1,
            descricaoLote: null,
            numeroItem: null,
            descricaoItem: null,
            tipoBeneficio: null,
            materialServico: null,
            fonteReferencia: null,
            dataReferencia: null,
            codigoDeReferencia: null,
            unidadeMedida: "",
            quantidade: 0,
            valorUnitario: 0,
            valorTotal: 0,
            bdi: null,
            indiceAtualizacao: null,

            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            quantidadeConfig: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
        }
    },

    validations: {
        idContratoSelecionado: {
            required
        },
        // numeroDoLote: {
        //     required,
        // },
        descricaoLote: {
            required,
            maxLength: maxLength(100)
        },
        numeroItem: {
            required,
        },
        descricaoItem: {
            required,
            maxLength: maxLength(8000)
        },
        tipoBeneficio: {
            required,
        },
        materialServico: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.materialServico)
            }
        },
        fonteReferencia: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.fonteReferencia)
            }
        },
        dataReferencia: {
            dataValida()  {
                return this.dataDeReferenciaValida
            }
        },
        codigoDeReferencia: {
          required,
          maxLength: maxLength(100)
        },
        unidadeMedida: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.unidadeMedida)
            }
        },
        quantidade: {
            required
        },
        valorUnitario: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.valorUnitario)
            }
        },
        valorTotal: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.valorTotal)
            }
        },
        bdi: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.bdi)
            }
        },
        indiceAtualizacao: {
            verificarPreenchimento()  {
                return this.verificarCampoPreenchido(this.indiceAtualizacao)
            }
        },
    },

    created() {
        this.obterListaFonteReferencia()
        this.obterListaIndiceAtualizacoes()
        this.obterListaTipoBenefico()
        this.obterContratos()
    },

    watch: {
        codigoDeReferencia (v) {
            if (typeof v === 'string' && v.length > 100) {
            this.codigoDeReferencia = v.slice(0, 100)
            }
        },
        quantidade() { this.calcularValorTotal() },
        valorUnitario() { this.calcularValorTotal() },
        idContratoSelecionado () {
            if (this.idContratoSelecionado !== null) {
                this.obterDadosContrato();
            }
        }
    }
}
</script>